// firebase.js
// import { initializeApp } from 'https://www.gstatic.com/firebasejs/9.0.0/firebase-app.js';
// import { getMessaging, getToken, onMessage } from 'https://www.gstatic.com/firebasejs/9.0.0/firebase-messaging.js';

import { initializeApp } from 'firebase/app';
import { getMessaging } from 'firebase/messaging';

const firebaseConfig = {
    apiKey: 'AIzaSyA0ViM3EnVCk8uFespNR3lthZoHpWaCZo0',
    authDomain: 'therapylake-edd6d.firebaseapp.com',
    projectId: 'therapylake-edd6d',
    storageBucket: 'therapylake-edd6d.appspot.com',
    messagingSenderId: '679990278879',
    appId: '1:679990278879:web:206ab9347d4f5c7651076a',
    measurementId: 'G-WLMDMD76VD',
};

const app = initializeApp(firebaseConfig);

/**
 * Guard Firebase Cloud Messaging initialisation.
 *
 * getMessaging() throws in browsers that lack the Push API or
 * Service Worker support — notably the Instagram in-app browser on
 * iOS.  Because this module is imported at the top of App.js, an
 * unguarded throw here crashes the entire app before React mounts,
 * producing a blank white page.
 *
 * We check for the required browser APIs first and fall back to null
 * so the rest of the app can simply skip messaging features when
 * `messaging` is null.
 */
const isMessagingSupported =
    typeof window !== 'undefined' &&
    'serviceWorker' in navigator &&
    'PushManager' in window &&
    'Notification' in window;

let messaging = null;
if (isMessagingSupported) {
    try {
        messaging = getMessaging(app);
    } catch (e) {
        // Silently degrade — messaging is non-critical for landing pages
        console.warn('Firebase Messaging could not be initialised:', e);
    }
}

export { messaging };
